import apiConfig from '../apiConfig';
import { getAxiosInstance } from '../../utils/axiosApi';
import axios from 'axios';

const axiosInstance = getAxiosInstance({
  baseUrl: apiConfig.PortalAPIUrl,
});

const checkUserOnHold = async (props) => {
  const { clientIds } = props || {};
  try {
    const queryParams = [];
    if (Array.isArray(clientIds) && clientIds.length > 0) {
      queryParams.push(`clientIDs=${clientIds.join(',')}`);
    }

    const queryParamVal = queryParams.join('&');
    const res = await axiosInstance.get(`/Client/CheckOnHoldClients?${queryParamVal}`);

    return res.data;
  } catch (e) {
    throw new Error('Something went wrong');
  }
};

const searchClients = async (
  {
    clientName,
    active,
    page,
    pageSize,
    sortBy,
    shortName,
    SourceSystemId
  }
) => {
  const queryParams = [];

  if (clientName && clientName.trim() !== '') {
    queryParams.push(`ClientName=${encodeURIComponent(clientName.trim())}`);
    queryParams.push('ClientNameOP=Contains');
  }

  if (active != null) {
    queryParams.push(`Active=${!!active}`);
  }

  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }
  if (shortName) {
    queryParams.push(`ShortName=${shortName}`);
  }
  if (SourceSystemId) {
    queryParams.push(`SourceSystemId=${SourceSystemId?.id}`);
  }
  try {
    const response = await axiosInstance.get(
      `/Client/Search/by?${queryParams.join('&')}`
    );
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};
const searchPetrohubClients = async (
  {
    clientName,
    active,
    page,
    pageSize,
    sortBy,
    ShortName,
    SourceSystemRecordID,
    SourceSystemId
  }
) => {
  const queryParams = [];
  if (clientName && clientName.trim() !== '') {
    queryParams.push(`ClientName=${encodeURIComponent(clientName.trim())}`);
    queryParams.push('ClientNameOP=Contains');
  }
  if (active != null) {
    queryParams.push(`Active=${!!active}`);
  }

  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }
  if (ShortName) {
    queryParams.push(`ShortName=${ShortName}`);
  }
  if (SourceSystemRecordID) {
    queryParams.push(`SourceSystemRecordID=${SourceSystemRecordID}`);
  }
  if (SourceSystemId) {
    queryParams.push(`SourceSystemId=${SourceSystemId?.id}`);
  }
  try {
    const response = await axiosInstance.get(
      `/Client/SearchPetrohub/By?${queryParams.join('&')}`
    );
    // console.log(response);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};
const getPetrohubClientByID = async (clientID) => {
  try {
    const response = await axiosInstance.get(`/Client/SearchPetrohub/ById/${clientID}`);
    // console.log(response);

    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const getPetroHubClientsByClientIds = async ({ clientIds }) => {
  try {
    if (!Array.isArray(clientIds) || clientIds.length === 0) {
      return [];
    }
    const response = await axiosInstance.get(
      `/masterdata/clients/ids/${clientIds.join(',')}/petrohub`
    );
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return [];
};

const updatePetrohubClientInfo = async (clientData) => {
  try {
    const response = await axiosInstance.post('/Client/UpdatePetrohub', clientData);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};
const addPetrohubClientAddress = async (clientData) => {
  try {
    const response = await axiosInstance.post('/Address/Create', clientData);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};
const updatePetrohubClientAddress = async (clientData) => {
  try {
    const response = await axiosInstance.post('/Address/Update', clientData);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};
const getPetrohubClientAddressByID = async (addressID) => {
  try {
    const response = await axiosInstance.get(`/Address/AddressId/${addressID}`);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};
const getClientByID = async (clientID) => {
  try {
    const response = await axiosInstance.get(`/Client/SearchPetrohub/ById/${clientID}`);
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};
const fetchAllClientsFuel = async ({
  clientName,
  clientNameOP,
  sourceSystemIds,
  functionality,
  reportAddressIDs = '',
  scenarioIDs = '',
  active,
  sortBy,
  page = 1,
  pageSize = 99999,
}) => {
  const queryParams = [];

  if (clientName && clientName.trim() !== '') {
    queryParams.push(`clientName=${encodeURIComponent(clientName.trim())}`);
  }

  if (clientNameOP && clientNameOP.trim() !== '') {
    queryParams.push(`clientNameOP=${encodeURIComponent(clientNameOP.trim())}`);
  }
  if (active) {
    queryParams.push(`active=${active}`);
  }
  if (Array.isArray(sourceSystemIds) && sourceSystemIds.length > 0) {
    queryParams.push(`sourceSystemIds=${sourceSystemIds.join(',')}`);
  }
  if (functionality && functionality.trim() !== '') {
    queryParams.push(`functionality=${encodeURIComponent(functionality.trim())}`);
  }
  if (reportAddressIDs && reportAddressIDs.trim() !== '') {
    queryParams.push(`reportAddressIDs=${encodeURIComponent(reportAddressIDs.trim())}`);
  }
  if (scenarioIDs && scenarioIDs.trim() !== '') {
    queryParams.push(`scenarioIDs=${encodeURIComponent(scenarioIDs.trim())}`);
  }
  if (sortBy && sortBy.trim() !== '') {
    queryParams.push(`sortBy=${encodeURIComponent(sortBy.trim())}`);
  }

  queryParams.push(`currentPage=${page}`);
  queryParams.push(`pageSize=${pageSize}`);
  try {
    const queryParamVal = queryParams.join('&');
    const response = await axiosInstance.get(
      `/masterdata/clients/all/fuel?${queryParamVal}`
    );
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};
const ClientApi = {
  checkUserOnHold,
  getClientByID,
  searchClients,
  getPetroHubClientsByClientIds,
  searchPetrohubClients,
  addPetrohubClientAddress,
  getPetrohubClientByID,
  updatePetrohubClientAddress,
  updatePetrohubClientInfo,
  getPetrohubClientAddressByID,
  fetchAllClientsFuel
};

export default ClientApi;
